export default __webpack_public_path__ + "static/media/tiktok_osadz.5a99eeb9.webp";